import { Component, OnInit,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormGroupDirective  } from  '@angular/forms';
import { ApiHandlerService } from '../../shared/services/api-handler.service';
import { ToasterService } from '../../shared/services/toaster.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  contactForm : FormGroup;
  public isLoadingData : boolean = false; 
  public submitted :boolean =false;
  public addedQuery : boolean = false;
  // @ViewChild(FormGroupDirective) contactFormGroupDirective: FormGroupDirective;'

  constructor(
    public formBuilder : FormBuilder,
    public _service    : ApiHandlerService,
    public toaster : ToasterService) { }

    ngOnInit(): void {
      let footer = document.getElementsByTagName('footer');
      footer[0].classList.add('without-cars'); 
      if(footer[1]){
        footer[1].classList.add('without-cars'); 
      }    
    }


    ngOnDestroy(){
      let footer = document.getElementsByTagName('footer')[0];
      footer.classList.remove('without-cars');    
    }


}
